import { Injectable } from '@angular/core';
import {ApiService} from './api.service';
import {Election} from '../../api/models/election';
import {LocaleService} from './locale.service';
import {empty} from '../../functions';

/**
 * @deprecated Use `ElectionService` from
 * `src/app/api/services/election.service.ts`. This hand-written wrapper
 * predates the generated client, returns `Observable<any>`, and will be
 * removed once all callers have migrated.
 */
@Injectable({
  providedIn: 'root'
})
export class ElectionService {

  constructor(
    private api: ApiService,
    private locale: LocaleService
  )
  {

  }

  getActive()
  {
    this.api.setEndpoint('election/active');
    return this.api.GET();
  }

  getTranslatedTitle(entity: Election) {
    const language = this.locale.getCurrentLanguage().toLowerCase();
    let result:any = entity.title;

    switch (language) {

      case 'en':
        if (!empty(entity.titleEn)) result = entity.titleEn;
        break;

    }

    return result;
  }


  getTranslatedDescription(entity: Election) {
    const language = this.locale.getCurrentLanguage().toLowerCase();
    let result:any = entity.description;

    switch (language) {

      case 'en':
        if (!empty(entity.descriptionEn)) result = entity.descriptionEn;
        break;

    }

    return result;
  }

  getTranslatedExtraInfo(entity: Election) {
    const language = this.locale.getCurrentLanguage().toLowerCase();
    let result:any = entity.extraInfo;

    switch (language) {

      case 'en':
        if (!empty(entity.extraInfoEn)) result = entity.extraInfoEn;
        break;

    }

    return result;
  }

}
